var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 24.25,
    viewBox: "0 0 24.5 24.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2520",
    d: "M562.5 569.5h-9a1 1 0 0 1-1-1v-6a5 5 0 0 1 5-5h0a5 5 0 0 1 5 5z",
    style: {
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      fill: "none",
      stroke: "#191919"
    },
    transform: "translate(-551.75 -551.75)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2521",
    d: "M557.5 569.5h17a1 1 0 0 0 1-1v-6a5 5 0 0 0-5-5h-13",
    style: {
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      fill: "none",
      stroke: "#191919"
    },
    transform: "translate(-551.75 -551.75)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 443",
    transform: "translate(13.75 .75)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      fill: "none",
      stroke: "#191919"
    },
    d: "M0 10V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1620",
    transform: "translate(13.75 .75)",
    style: {
      fill: "#2a32ff",
      stroke: "#2a32ff",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      strokeLinecap: "round"
    },
    d: "M0 0h5v3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 444",
    transform: "translate(14.75 17.75)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none",
      stroke: "#191919"
    },
    d: "M0 0v6.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 445",
    transform: "translate(11.75 17.75)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none",
      stroke: "#191919"
    },
    d: "M0 0v6.5"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.45edb2a533872f2a32891a41da5c5576.svg";
export { ForwardRef as ReactComponent };